import { ActionReducerMap } from "@ngrx/store";

import { contentSectionReducer } from "./src/content-section/content-section.reducer";
import { flagReducer } from "./src/flag/flag.reducer";
import { iconReducer } from "./src/icon/icon.reducer";
import { imageReducer } from "./src/image/image.reducer";
import { menuReducer } from "./src/menu/menu.reducer";
import { quicklinkReducer } from "./src/quicklink/quicklink.reducer";
import { CoreContentState } from "./src/state";
import { translationReducer } from "./src/translation/translation.reducer";

export { ContentClient } from "./src/content/content.client";
export { ContentConfigService } from "./src/content/content.config";

export {
	ButtonContent,
	ContentApplicationState,
	ContentApplicationType,
	ContentCache,
	ContentDocumentGroup,
	ContentDocument,
	ContentGroupType,
	ContentPlatformState,
	ContentPlatformType,
	ContentUserState,
	ImageContent,
	ContentTermsAndConditionsState,
	LabelContent,
	LinkButton,
	LinkContent,
	LinkContentItems,
	UserStates,
} from "./src/content/content.model";

export { Banner } from "./src/filtered-content/banner/banner.model";

export {
	ContentSection,
	ContentSectionGroup,
	ContentSectionResponse,
	ContentSectionState,
} from "./src/content-section/content-section.model";
export { contentSectionMessageContext } from "./src/content-section/content-section.const";
export { ContentSectionAction, CONTENT_SECTION_ACTION_TYPE } from "./src/content-section/content-section.action";
export { ContentSectionEffect } from "./src/content-section/content-section.effect";
export { contentSectionReducer } from "./src/content-section/content-section.reducer";
export { ContentSectionSelector } from "./src/content-section/content-section.selector";
export { ContentSectionService } from "./src/content-section/content-section.service";

export { FlagAction, FLAG_ACTION_TYPE } from "./src/flag/flag.action";
export { flagContext } from "./src/flag/flag.const";
export { FlagEffect } from "./src/flag/flag.effect";
export { Flag, FlagContent, FlagResponse, FlagState, FlagTextContentItems, RawFlag } from "./src/flag/flag.model";
export { flagReducer } from "./src/flag/flag.reducer";
export { FlagSelector } from "./src/flag/flag.selector";
export { FlagService } from "./src/flag/flag.service";

export { IconAction } from "./src/icon/icon.action";
export { IconEffect } from "./src/icon/icon.effect";
export { Icon, IconResponse, IconState, Metadata } from "./src/icon/icon.model";
export { iconReducer } from "./src/icon/icon.reducer";
export { IconSelector } from "./src/icon/icon.selector";
export { IconService } from "./src/icon/icon.service";

export { ImageAction } from "./src/image/image.action";
export { ImageEffect } from "./src/image/image.effect";
export { ImageContentDictionary, Images, ImagesPayload, ImageState } from "./src/image/image.model";
export { imageReducer } from "./src/image/image.reducer";
export { ImageSelector } from "./src/image/image.selector";
export { ImageService } from "./src/image/image.service";

export { MenuAction } from "./src/menu/menu.action";
export { menuMessageContext } from "./src/menu/menu.const";
export { MenuEffect } from "./src/menu/menu.effect";
export {
	MenuItem,
	MenuItemGroup,
	MenuMetadata,
	MenuResponse,
	MenuResponseContent,
	MenuResponseItem,
	MenuState,
} from "./src/menu/menu.model";
export { menuReducer } from "./src/menu/menu.reducer";
export { MenuSelector } from "./src/menu/menu.selector";
export { MenuService } from "./src/menu/menu.service";

export { MessageCodeFallbackService } from "./src/message-code-fallback/message-code-fallback.service";
export { MessageCodeFallbackPipe } from "./src/message-code-fallback/message-code-fallback.pipe";

export { Quicklink, QuicklinkResponse, QuicklinkState } from "./src/quicklink/quicklink.model";
export { quicklinkMessageContext } from "./src/quicklink/quicklink.const";
export { QuicklinkAction, QUICKLINK_ACTION_TYPE } from "./src/quicklink/quicklink.action";
export { QuicklinkEffect } from "./src/quicklink/quicklink.effect";
export { quicklinkReducer } from "./src/quicklink/quicklink.reducer";
export { QuicklinkSelector } from "./src/quicklink/quicklink.selector";
export { QuicklinkService } from "./src/quicklink/quicklink.service";

export { TranslationAction } from "./src/translation/translation.action";
export { translationMessageContext } from "./src/translation/translation.const";
export { TranslationEffect } from "./src/translation/translation.effect";
export { GetSuccessPayload, TranslationState } from "./src/translation/translation.model";
export { translationReducer } from "./src/translation/translation.reducer";
export { TranslationSelector } from "./src/translation/translation.selector";
export { TranslationService } from "./src/translation/translation.service";
export { TranslationGroup, TranslationOptions } from "./src/translation/translation.model";

export { CoreContentState } from "./src/state";
export { CoreContentModule } from "./src/module";
export { ListOrientation } from "./src/const";
export { ListItem, MetadataDeviceType } from "./src/model";

export const CORE_CONTENT_REDUCER: ActionReducerMap<Partial<CoreContentState>> = {
	image: imageReducer,
	menu: menuReducer,
	translation: translationReducer,
	quicklink: quicklinkReducer,
	flag: flagReducer,
	contentSection: contentSectionReducer,
	icon: iconReducer,
};

export * from "./src/module";
export { FetchSuccessPayload } from "./src/menu/menu.model";
